var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-header"},[_c('div',{staticClass:"container"},[_c('a',{attrs:{"href":"https://rebilly.com"}},[_c('svg',{staticClass:"logo"},[_c('use',{attrs:{"xlink:href":"#rebilly-logo"}})])])])])}
var staticRenderFns = []

export { render, staticRenderFns }